import _constantUtil from '../utils/Constant';

const evalution = (_constantUtil.ENVIORNMENT === 'development');

const config = {
    appBaseUrl : (evalution ? process.env.REACT_APP_BASE_URL : '') + _constantUtil.API_PREFIX
}

export default config;